/* eslint-disable */
import colors from '../../../../../public/colors'


export default theme => {
    const { mode } = theme.palette
    return {
    actionRow: {
        '& > button': {
            marginLeft: 'auto'
        },
        justifyContent: 'flex-end',
        height: '100%'
    },
    button: {
        '&.MuiButton-root': {
            border: '1px solid #006AC3',
            borderRadius: '4px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            height: '40px',
            marginLeft: '10px',
            width: '104px'
        }
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'end',
        gap:'2%',
        width: '100%'
    },
    backButton: {
        '&.MuiButton-root': {
            backgroundColor: colors[mode].insightCardHover,
            border: `1px solid ${colors[mode].cardImageTextAppHover}`,
            boxShadow: 'none',
            color: colors[mode].mfaActiveBackground,
            height: '32px',
            padding: '8px 16px',
            width: 'auto'
        }            
    },
    introText: {
        paddingLeft: '24px',
        paddingRight: '24px',
        marginTop: '2%',
        marginBottom: '5%',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '16px',
            paddingRight: theme.spacing(1),
            paddingTop: '16px'
        }
    },
    secret: {
        paddingTop: '10%',
        textAlign: 'center',
        height: '100px',
        fontSize: '1.5rem',
        color: colors[mode].mfaActiveBackground
    },
    subTitle: {
        color: colors[mode].cardDescription,
        fontSize: '0.875rem',
        letterSpacing: '0.17px',
        lineHeight: '1.25rem'
    },
    nextButton: {
        '&.MuiButton-root': {
            backgroundColor: '#FEDF01',
            borderRadius: '2px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            color: '#003168',
            height: '32px',
            padding: '8px 16px',
            width: 'auto',
            [theme.breakpoints.down('sm')]: {
                height: '30px'
            },
            [theme.breakpoints.down('xs')]: {
                height: '25px'
            }
        }
    },
    content: {
        fontSize: '24px',
        fontWeight: '500'
    },
    contentContainer: {
        borderRadius: '3px',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    contentDivider: {
        paddingTop: '20px'
    },
    contentSection: {
        fontSize: '20px'
    },
    fieldsContainer: {
        '@media screen and (max-width: 320px)': {
            alignItems: 'start'
        },
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
        width: '100%'
    },
    link: {
        fontSize: '16px',
        letterSpacing: '0',
        lineHeight: '18px',
        paddingTop: '18px',
        paddingLeft: '43%'
    },
    helpText: {
        fontStyle: 'italic',
        padding: '2% 4%'
    },
    qrCodeImg: {
        border: '1px solid rgba(0,0,0,0.54)',
        marginTop: '23px',
        width: '143px'
    },
    show: {
        display: 'block'
    },
    hide: {
        display: 'none'
    },
    loader: {
        height: '100%',
        left: '0',
        position: 'absolute',
        top: '0',
        width: '100%',
        'z-index': '10'
    },
    root: {
        padding: theme.spacing(0, 2, 2, 2)
    },
    stepper: {
        width: '50%',
        margin: 'auto'
    },
    stepperContainer: {
        width: '100%'
    },
    container: {
        display: 'grid'
    },
    setupIcon:{
            width: '182px',
    height: '182px',
    border: '1px solid #E1E4E6',
    }
}}
